"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/** planned for deprecation */
function setUIProps(props) {
    var dataAttr = getAttributesStartsWith('data-', props);
    var ariaAttr = getAttributesStartsWith('aria-', props);
    //include all props from UIProps interface
    var UIPropsKeys = [
        'id',
        'className',
        'tabIndex',
        'title',
        'hidden',
        'accessKey',
        'contentEditable',
        'spellCheck',
        'dir',
        'draggable',
        'lang',
        'translate',
        'role',
        'onMouseOver',
        'onMouseOut',
        'onMouseDown',
        'onMouseUp',
        'onClick',
        'onFocus',
    ];
    var filteredProps = {};
    for (var key in props) {
        if (UIPropsKeys.includes(key))
            filteredProps[key] = props[key];
    }
    return __assign(__assign(__assign({}, filteredProps), dataAttr), ariaAttr);
    // return {
    //   id: props.id,
    //   className: props.className,
    //   tabIndex: props.tabIndex === 0 ? undefined : props.tabIndex,
    //   title: props.title,
    //   hidden: props.hidden,
    //   accessKey: props.accesskey,
    //   contentEditable: props.contenteditable,
    //   spellCheck: props.spellcheck,
    //   dir: props.dir,
    //   draggable: props.draggable,
    //   lang: props.lang,
    //   translate: props.translate,
    //   ...dataAttr,
    //
    //   role: props.role,
    //   ...ariaAttr,
    //
    //   onMouseOver: props.onMouseOver,
    //   onMouseOut: props.onMouseOut,
    //   onMouseDown: props.onMouseDown,
    //   onMouseUp: props.onMouseUp,
    //   onClick: props.onClick,
    //   onFocus: props.onFocus,
    // }
}
exports.setUIProps = setUIProps;
function getAttributesStartsWith(query, props) {
    var attributes = {};
    for (var key in props) {
        if (key.startsWith(query))
            attributes[key] = props[key];
    }
    return attributes;
}
